import axios from 'axios'
import { AuthStorage } from '../storage/index'
import { historyObject } from '../constants/index'


/**
 * CLASSE FOR RESOURCES
 */
export class Resources {
  /**
   * Construct
   * @param {String} baseUrl
   */
  constructor ( baseUrl, endpoint = null ) {
    
    this.endpoint = !endpoint 
      ? process.env.REACT_APP_API_URL
      // process.env.NODE_ENV === 'development'
      //   ? 'http://magazines.localhost'
      //   : 'https://api-magazine.omb11.com'
      : endpoint
    this.baseUrl = `${this.endpoint}/${baseUrl}`
    this.http = axios.create( {
      baseURL: this.baseUrl
    } )

    this.setInterceptors()
  }

  /**
   * SET THE INTERCEPTORS
   */
  setInterceptors () {
    this.http.interceptors.request.use( config => {
      const user = JSON.parse(  AuthStorage.getValue() )
      if( user ) {
        config.headers = Object.assign(
          config.headers,
          { Authorization: `Bearer ${user.accessToken}` }
        )
      }
      return config
    }, error => {
      return Promise.reject( error )
    } )

    this.http.interceptors.response.use( config => {
      return config
    }, error => {
      if( error.response.status === 404 ){
        historyObject.replace( '/404' )
      }

      if( error.response.status === 403 ){
        historyObject.replace( '/' )
        AuthStorage.deleteValue()
      }
      return Promise.reject( error )
    } )
  }

  /**
   * GET ALL RECORDS
   * @param {Object} opts
   */
  fetchAll ( opts ) {
    return this.http.get( this.baseUrl, opts )
  }

  /**
   * GET ITEM BY ID
   * @param {String} id
   */
  getById ( id, params ) {
    return this.http.get( `${this.baseUrl}/${id}`, {
      params: params
    } )
  }

  /**
   * SAVA A RESOURCE
   * @param {Object} data
   */
  save ( data ) {
    return this.http.post( `${this.baseUrl}`, data )
  }

  /**
   * UPDATE A RESROUCE
   * @param {Object} data
   * @param {String} id
   */
  update ( data, id ) {
    return this.http.put( `${this.baseUrl}/${id}`, data )
  }

  /**
   * Delete a specific item
   * @param {Integer} id 
   */
  delete ( id ) { 
    return this.http.delete( `${this.baseUrl}/${id}` )
  }

  /**
   * Change the current base url
   * @param {String} url 
   */
  setBaseUrl ( url ) {
    this.baseUrl = url
    return this
  }

  getEndPoint () {
    return this.endpoint
  }
}



// WEBPACK FOOTER //
// ./src/resources/resources.js